import React, { useEffect, useRef, useState } from "react";
import client from "@culturehq/client";
import { ModalDialog, PlainButton } from "@culturehq/components";
import { useDoor } from "app/hooks";
import { errorService, Trans } from "app/utils";

import ErrorBoundary from "components/common/ErrorBoundary";
import ChqModalDialog from "components/common/ChqModalDialog";
import SortBySelected from "./SortBySelected";
import Stories from "./Stories";
import StorySearchBar from "./StorySearchBar";
import DisplayStories from "./DisplayStories";

const ApproveStoryButton = ({ onOpen, selectedStories }) => (
  <PlainButton className="Approve-Button" onClick={onOpen}>
    <DisplayStories selectedStories={selectedStories} />
  </PlainButton>
);

const ApproveStoryModal = ({
  initialOpen = false, landingPage, onSelectedStories, setApprovingContent
}) => {
  const [state, setState] = useState({
    page: 1,
    query: null,
    redirectToEvent: false,
    layout: "grid"
  });
  const [stories, setStories] = useState([]);
  const [query, setQuery] = useState("");
  const [sortBy, setSortBy] = useState("selected");
  const [selectedStories, setSelectedStories] = useState([]);
  const { open, onOpen, onClose } = useDoor(initialOpen);
  const feedRef = useRef();

  const handleOpenModal = () => {
    setApprovingContent(true);
    onOpen();
  };

  const handleCloseModal = () => {
    setApprovingContent(false);
    onClose();
  };

  useEffect(() => {
    if (landingPage?.stories?.length > 0) {
      setSelectedStories(landingPage.stories);
    }
  }, [landingPage]);

  const getStoriesWithSelectedValue = stories => (
    selectedStories.length > 0
      ? stories.map(story => (
        {
          ...story,
          selected: !!selectedStories.find(selectedStory => selectedStory.id === story.id)
        }
      )) : stories
  );

  const fetchStories = async () => {
    try {
      const { stories, pagination } = await client.listStories({ states: ["landing_page", "approved_for_everything"] });
      setStories(getStoriesWithSelectedValue(stories));
    } catch (error) {
      errorService.error(error);
    }
  };

  const handleResults = ({ stories, pagination, query }) => {
    setQuery(query);
    if (!query) {
      fetchStories();
    } else {
      setStories(getStoriesWithSelectedValue(stories));
    }
  };

  const handleSelected = async changedStory => {
    if (landingPage) {
      await client.createLandingPageStory({
        landingPageId: landingPage.id,
        storyId: changedStory.id
      });
    }
    const selected = [...selectedStories, changedStory];
    setSelectedStories(selected);
    onSelectedStories(selected);
  };

  const handleUnselected = async changedStory => {
    await client.deleteLandingPageStory({
      landingPageId: landingPage.id,
      storyId: changedStory.id
    });
    const selected = selectedStories.filter(story => story.id !== changedStory.id);
    setSelectedStories(selected);
    onSelectedStories(selected);
  };

  const handleSortValue = value => {
    setSortBy(value);
  };

  const modalStyle = {
    overlay: {
      minHeight: "100vh",
      position: "absolute"
    }
  };

  return (
    <>
      {open && (
        <ChqModalDialog style={modalStyle} onClose={handleCloseModal} className="ApproveStoryModal" entrance="zoomIn" ariaLabelledBy="approve-story-title" ariaDescribedby="approve-story-title">
          <ModalDialog.Heading titleId="approve-story-title" onClose={handleCloseModal}>
            <Trans>Select Story Spotlights</Trans>
          </ModalDialog.Heading>
          <ModalDialog.Body ref={feedRef}>
            <DisplayStories selectedStories={selectedStories} />
            <hr className="row Separator" />
            <div className="Stories__cards row">
              <div className="col-xs-12 Stories__cards__SearchBar">
                <div className="row">
                  <div className="col-xs-8 SearchBar">
                    <StorySearchBar
                      onResults={handleResults}
                      page={state.page}
                    />
                  </div>
                  <div className="col-xs-4">
                    <SortBySelected
                      value={sortBy}
                      onSelected={handleSortValue}
                    />
                  </div>
                </div>
              </div>
              <div className="col-xs-12">
                <ErrorBoundary>
                  <Stories
                    landingPageId={landingPage.id}
                    feedRef={feedRef}
                    onSelected={handleSelected}
                    onUnselected={handleUnselected}
                    sortBy={sortBy}
                    selectedStories={selectedStories}
                    stories={stories}
                    query={query}
                  />
                </ErrorBoundary>
              </div>
            </div>
          </ModalDialog.Body>
        </ChqModalDialog>
      )}
      <ApproveStoryButton
        onOpen={handleOpenModal}
        selectedStories={selectedStories}
      />
    </>
  );
};

export default ApproveStoryModal;
